<template>
  <teleport to="body">
    <div class="pay-hold" role="dialog" aria-modal="true" aria-labelledby="pay-hold-title">
      <div class="pay-hold__panel">
        <button type="button" class="pay-hold__x" aria-label="결제 안내 닫기" @click="$emit('close')">
          <AppIcon icon="mdi-close" :size="20" />
        </button>
        <p id="pay-hold-title" class="pay-hold__title">결제 중</p>
        <p class="pay-hold__text">
          토스 결제창을 닫아도 이 주문은 결제 대기로 남습니다. 아직 결제된 금액은 없습니다.
          새로고침하면 결제창을 다시 준비합니다.
        </p>
        <div class="pay-hold__actions">
          <button type="button" class="pay-hold__btn" @click="$emit('close')">닫기</button>
          <button type="button" class="pay-hold__btn is-go" @click="$emit('refresh')">새로고침</button>
        </div>
      </div>
    </div>
  </teleport>
</template>

<script setup lang="ts">
import AppIcon from '@/components/common/AppIcon.vue'

defineEmits<{
  close: []
  refresh: []
}>()
</script>

<style lang="scss" src="./MallPayHold.scss"></style>
